"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var date_fns_1 = require("date-fns");
var react_redux_1 = require("react-redux");
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var SearchBar_1 = __importDefault(require("atomicComponents/organisms/SearchBar"));
var backend_1 = require("utils/backend");
var single_1 = require("utils/selectors/single");
var CustomerTableMenu = function (_a) {
    var _b;
    var searchText = _a.searchText, setSearchText = _a.setSearchText;
    var _c = __read((0, backend_1.useCall)('companies-callUpdateCompaniesForAdminAggregates'), 2), callRefresh = _c[0], isRefreshing = _c[1];
    var siteInfo = (0, react_redux_1.useSelector)(single_1.selectHudledSiteInfo);
    var lastRefresh = (_b = siteInfo === null || siteInfo === void 0 ? void 0 : siteInfo.lastRefresh) === null || _b === void 0 ? void 0 : _b.companiesForAdmin;
    return ((0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ display: "flex", alignItems: "center", justifyContent: "space-between", mt: 1, ml: -1, width: "100%", maxWidth: 1550 }, { children: [(0, jsx_runtime_1.jsxs)(Button_1.default, __assign({ onClick: callRefresh(), isSending: isRefreshing }, { children: ["Refresh ", lastRefresh && "(last refreshed ".concat((0, date_fns_1.format)(lastRefresh.toDate(), 'yyyy-MM-dd @ hh:mm:ss'), ")")] })), (0, jsx_runtime_1.jsx)(SearchBar_1.default, { searchText: searchText, setSearchText: setSearchText })] })));
};
exports.default = CustomerTableMenu;
